import { Box, IconButton, Tooltip } from "@mui/material";
import { ClosedCaption, Subtitles } from "@mui/icons-material";
import React from "react";
import { useZoomPlayerStyles } from "./style";

type ControlsProps = {
  showTranscript: boolean;
  onToggleTranscript: () => void;
  showTranscriptOverlay: boolean;
  onToggleTranscriptOverlay: () => void;
  isTranscriptAvailable: boolean;
};

export const Controls: React.FC<ControlsProps> = ({
  showTranscript,
  onToggleTranscript,
  showTranscriptOverlay,
  onToggleTranscriptOverlay,
  isTranscriptAvailable,
}) => {
  const classes = useZoomPlayerStyles();
  const transcriptBtnClass = `${classes.iconBtn} ${
    !isTranscriptAvailable
      ? classes.iconDisabled
      : showTranscript
      ? classes.iconActive
      : classes.iconInactive
  }`;
  const subtitlesBtnClass = `${classes.iconBtn} ${
    !isTranscriptAvailable
      ? classes.iconDisabled
      : showTranscriptOverlay
      ? classes.iconActive
      : classes.iconInactive
  }`;

  return (
    <Box className={classes.controlsBar}>
      <Tooltip
        title={
          isTranscriptAvailable
            ? `Transcript: ${showTranscript ? "On" : "Off"}`
            : "Transcript not available"
        }
      >
        <span>
          <IconButton
            className={transcriptBtnClass}
            onClick={() => isTranscriptAvailable && onToggleTranscript()}
            disabled={!isTranscriptAvailable}
          >
            <ClosedCaption />
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip
        title={
          isTranscriptAvailable
            ? `Subtitles: ${showTranscriptOverlay ? "On" : "Off"}`
            : "Subtitles not available"
        }
      >
        <span>
          <IconButton
            className={subtitlesBtnClass}
            onClick={() => isTranscriptAvailable && onToggleTranscriptOverlay()}
            disabled={!isTranscriptAvailable}
          >
            <Subtitles />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};
